// extracted by mini-css-extract-plugin
module.exports = {"main":"ManualiTemplate_main__hiOyy","rotation":"ManualiTemplate_rotation__CVOom"};